export const mobilePlatformQueryParam = (queryParams: URLSearchParams) => {
  const { isWebMode } = useAppMode()

  if (isWebMode) {
    queryParams.set('platform', 'web')
  } else if (isPlatform('ios')) {
    queryParams.set('platform', 'ios')
  } else if (isPlatform('android')) {
    queryParams.set('platform', 'android')
  } else {
    queryParams.set('platform', 'all')
  }

  return queryParams
}
